import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import type {RootState} from 'store/types';
import type {Attempt} from './types';

export type ReceivedItemsState = Attempt[];

const initialState: ReceivedItemsState = [];

const receivedItemsSlice = createSlice({
  name: 'receivedItems',
  initialState,
  reducers: {
    receivedItemsUpdated: (_state, action: PayloadAction<Attempt[]>) => {
      return action.payload;
    },
    receivedItemsCleared: () => {
      return initialState;
    },
  },
});

export const {receivedItemsUpdated, receivedItemsCleared} =
  receivedItemsSlice.actions;
export const selectReceivedItems = (state: RootState) => state.receivedItems;

export default receivedItemsSlice;
